import R from 'ramda'

const ONLY_DISPLAY_TYPE = 'Only'
const ONLY_TRIGGER_TYPE = 'ONLY'

const isOnlyWidgetTrigger = R.propEq('type', ONLY_TRIGGER_TYPE)

const convertOnlyWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(ONLY_DISPLAY_TYPE),
  value: R.prop('data')
})

export { isOnlyWidgetTrigger, convertOnlyWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/widget-to-form/only.js